import React from "react";
import { useLocation, useHistory } from "react-router-dom";

export default function ErrorsPage() {
  const location = useLocation();
  const history = useHistory();
  const statusCode = location.state?.statusCode || 500;
  const title =
    location.state?.title ||
    (statusCode === 404 ? "We couldn't find that page." : "Something went wrong.");
  const description =
    location.state?.description ||
    "An unexpected application error occurred. Try refreshing or return to the dashboard.";

  /**
   * Navigate back to dashboard, clearing error state
   */
  const handleBackToDashboard = () => {
    // Use replace to avoid keeping error in history
    history.replace("/dashboard");
  };

  return (
    <div className="tw-flex tw-min-h-screen tw-items-center tw-justify-center tw-bg-gray-50 tw-px-6 dark:tw-bg-gray-900">
      <div className="tw-max-w-xl tw-space-y-6 tw-rounded-2xl tw-bg-white tw-p-10 tw-text-center tw-shadow-xl dark:tw-bg-gray-800">
        <div className="tw-text-5xl tw-font-black tw-text-blue-600 dark:tw-text-blue-300">
          {statusCode}
        </div>
        <div className="tw-space-y-2">
          <p className="tw-text-xl tw-font-semibold tw-text-gray-900 dark:tw-text-white">{title}</p>
          <p className="tw-text-sm tw-text-gray-600 dark:tw-text-gray-300">{description}</p>
        </div>
        <div className="tw-flex tw-justify-center tw-gap-3">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="tw-rounded-lg tw-bg-gray-200 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-gray-700 hover:tw-bg-gray-300 dark:tw-bg-gray-700 dark:tw-text-gray-200 dark:hover:tw-bg-gray-600"
          >
            Reload Page
          </button>
          <button
            type="button"
            onClick={handleBackToDashboard}
            className="tw-rounded-lg tw-bg-blue-600 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-blue-700"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
